import { history } from '../store/store';

export function setupNotificationClickHandler() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', event => {
      if (event.data.type === 'NOTIFICATION_CLICK' && event.data.chatId) {
        // Navigate to the chat
        if (history) {
          history.push(`/chat/${event.data.chatId}`);
        } else {
          // Fallback to window location
          window.location.href = `/chat/${event.data.chatId}`;
        }
      }
    });
  }
}